import CookieService from "./js/services/cookieService";
import AppService from "./js/services/appService";

if ('serviceWorker' in navigator) {
    let installPrompt = null;

    // Service Workers Supported
    const appInstallClassNames = {
        btnInstallApp: '.js-btn-install',
        btnUninstallApp: '.js-btn-uninstall',
        btnInstallReject: '.js-btn-install-reject',
        btnCloseIOSInstr: '.js-btn-install-ins-close',
        appScope: '.js-app-scope',
        installPrompts: 'install-prompts',
        uninstallPrompts: 'uninstall-prompts',
        iosInstall: 'ios-install',
        iosChrome: 'ios-chr'
    };

    const appInstallRejected = CookieService.get(AppService.cookieConsts.appInstallRejected) != null ? true : false;

    // Create Install App button events
    const createInstallBtnEvents = () => {
        const appInstallBtns = document.querySelectorAll(appInstallClassNames.btnInstallApp);
        const appInstallRejectBtns = document.querySelectorAll(appInstallClassNames.btnInstallReject);
        const closeIOSInstrBtns = document.querySelectorAll(appInstallClassNames.btnCloseIOSInstr);
        const appUninstallBtn = document.querySelector(appInstallClassNames.btnUninstallApp);

        if (appUninstallBtn) {
            appUninstallBtn.addEventListener("click", async () => {
                uninstallApp();
            });
        }

        if (appInstallBtns) {
            appInstallBtns.forEach(btn => {
                btn.addEventListener("click", async () => {
                    if (installPrompt) {
                        // only supported by certain browsers
                        const result = await installPrompt.prompt();

                        if (result.outcome === 'accepted') {
                            installApp();
                        } else {
                            return;
                        }

                        installPrompt = null;
                    }
                    else {
                        // likely IOS
                        installApp();
                    }
                });
            });
        }

        if (appInstallRejectBtns) {
            appInstallRejectBtns.forEach(btn => {
                btn.addEventListener("click", () => {
                    rejectAppInstall();
                });
            });
        }

        if (closeIOSInstrBtns) {
            closeIOSInstrBtns.forEach(btn => {
                btn.addEventListener("click", () => {
                    closeIOSInstr();
                });
            });
        }
    }

    // Show Install Prompts
    const showInstallPrompts = () => {
        document.querySelector(appInstallClassNames.appScope).classList.add(appInstallClassNames.installPrompts);
    };

    // Hide Install Prompts
    const hideInstallPrompts = () => {
        document.querySelector(appInstallClassNames.appScope).classList.remove(appInstallClassNames.installPrompts);
    };

    // Reject the App Install
    const rejectAppInstall = () => {
        CookieService.set(AppService.cookieConsts.appInstallRejected, "rejected", 3);
        document.querySelector(appInstallClassNames.appScope).classList.remove(appInstallClassNames.installPrompts);
    };

    const closeIOSInstr = () => {
        document.querySelector(appInstallClassNames.appScope).classList.remove(appInstallClassNames.iosInstall);
        CookieService.delete(AppService.cookieConsts.showIOSInstallInstr);
    };

    const HardReloadApp = () => {
        let loc = '/';
        window.location = loc;
    }

    // Install the app
    const installApp = () => {
        hideInstallPrompts();

        AppService.install(() => {
            // Set indicators that app installed for next time
            if (AppService.isIOS() === true) {
                CookieService.set(AppService.cookieConsts.showIOSInstallInstr, "show", 999);
            }

            HardReloadApp();
        });
    }

    // Uninstall the app
    const uninstallApp = () => {
        AppService.uninstall(() => {
            HardReloadApp();
        });
    }

    const showIOSInstallInstructions = () => {
        const appScope = document.querySelector(appInstallClassNames.appScope);
        appScope.classList.add(appInstallClassNames.iosInstall);

        if (AppService.isIOSChrome()) {
            // IOS Chrome
            appScope.classList.add(appInstallClassNames.iosChrome);
        }
    };

    // Detect if app is installed (Including a partial install)
    const init = (appIsInstalledFn, appNotInstalledFn) => {
        AppService.appIsInstalled().then(
            result => {
                if (result === true) {
                    appIsInstalledFn();
                    const showIOSInstallInstrs = AppService.isIOS() === true && CookieService.get(AppService.cookieConsts.showIOSInstallInstr) !== null ? true : false;

                    if (AppService.appIsRunningStandalone() === false && showIOSInstallInstrs === true) {
                        showIOSInstallInstructions();
                    }
                }
                else {
                    appNotInstalledFn();
                }
            },
            () => {
                console.log('Aro App Install check failed');
            }
        );
    }

    const appNotInstalledCallBackFn = () => {
        const userHasRegistered = CookieService.get(AppService.cookieConsts.userHasRegistered) != null ? true : false;

        if (appInstallRejected === false && userHasRegistered === false) {
            // App is not installed + User has not cancelled the Install Prompts
            if (AppService.isIOS() === false) {
                window.addEventListener("beforeinstallprompt", (event) => {
                    // If this event fires then PWA supported - show install prompts
                    installPrompt = event;

                    showInstallPrompts();
                    return event.preventDefault();
                });
            }
            else {
                // IOS and not running in standalone mode (so not already installed) - show install prompts
                showInstallPrompts();
            }
        }
        else {
            // otherwise do nothing as user must have rejected the app install
            console.log('Aro app install previously cancelled');
        }
    }

    const appIsInstalledCallbackFn = () => {
        document.querySelector(appInstallClassNames.appScope).classList.add(appInstallClassNames.uninstallPrompts);

        // App is installed so update to latest service worker
        window.addEventListener('load', onWindowLoad);
    }

    const onWindowLoad = () => {
        // Auto update SW to latest version 
        navigator.serviceWorker.register('/service-worker.js').then(async (registration) => {
            if (registration) {
                console.info('Aro app updated:', registration);

                // Ask user for permission
                if (typeof window.OfferNotifications === 'function') {
                    window.OfferNotifications(registration).then((msg) => {
                        console.log(msg);
                    });
                }
            }
        });
    }

    createInstallBtnEvents();
    init(appIsInstalledCallbackFn, appNotInstalledCallBackFn);
}
else {
    console.log('Aro app not supported');
}

